/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DocumentsControllerService } from './services/documents-controller.service';
import { DocumentGeneratorControllerService } from './services/document-generator-controller.service';
import { DocumentsArchiveControllerService } from './services/documents-archive-controller.service';
import { PublicDocumentsControllerService } from './services/public-documents-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DocumentsControllerService,
    DocumentGeneratorControllerService,
    DocumentsArchiveControllerService,
    PublicDocumentsControllerService,
    ApiConfiguration
  ],
})
export class MyasiDocumentCoreModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MyasiDocumentCoreModule> {
    return {
      ngModule: MyasiDocumentCoreModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MyasiDocumentCoreModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MyasiDocumentCoreModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
